<main class="main-dashboard">
    <article class="main-canvas">
        <section class="canvas-container">
            <section class="dashboard-items">
                <div class="canvas-item">
                    <div class="canvas-header row justify-content-between align-items-center">
                        <div class="title col-sm-6">
                            <h3> Guest Book </h3>
                        </div>
                        <div class="col-sm-6" style="display: flex; justify-content: flex-end; align-items: center;">
                            <div class="edit" *ngIf="selectedCheckboxData.length === 1">
                                <button type="button" title="Edit" (click)="editOpenModal()" data-bs-toggle="modal" data-bs-target="#createVisitor">
                                    <span><i class="ri-pencil-line"></i></span>
                                </button>
                            </div>
                            <div class="delete" *ngIf="selectedCheckboxData.length > 0">
                                <button type="button" title="Delete" data-bs-toggle="modal" data-bs-target="#deleteVisitor" (click)="deleteOpenModal()">
                                    <span><i class="ri-delete-bin-5-line"></i></span>
                                </button>
                            </div>
                            <div>
                                <button type="button" title="Create" (click)="createOpenModal()" data-bs-toggle="modal" data-bs-target="#createVisitor" class="btn btn-icon">
                                    <i class="ri-add-line"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <ag-grid-angular
                    style="height: calc(100vh - 120px) !important;"
                         class="ag-theme-material"
                        (gridReady)="onGridReady($event)" 
                        [rowData]="rowData" 
                        [columnDefs]="columnDefs"
                        pagination="true" 
                        [defaultColDef]="defaultColDef"
                        [suppressRowClickSelection]="true"
                        [rowSelection]="rowSelection"
                        (selectionChanged)="onSelectionChanged($event)"
                        paginationPageSize=10>
                    </ag-grid-angular>
                </div>
            </section>
        </section>
    </article>
</main>

<!-- Create new Lead -->
<div class="modal fade" id="createVisitor" tabindex="-1">
    <div class="modal-dialog">
        <div class="modal-content pl-5 pr-5">
            <form [formGroup]="visitorForm">
                <div class="modal-header">
                    <h5 class="modal-title">Register Visitor</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                    <div class="input">
                        <div class="input-item">
                            <input formControlName="name" type="text" required>
                            <label for="name" class="floating-label">Name</label>
                            <i class="ri-file-list-line"></i>
                        </div>
                        <mat-error *ngIf="f.name.touched && f.name.invalid" class="alert alert-danger">
                            <mat-error *ngIf="f.name.errors.required">Name is required</mat-error>
                            <mat-error *ngIf="f.name.errors.pattern">Name can only contain alphabet</mat-error>
                        </mat-error>
                    </div>
                    <div class="input">
                        <div class="input-item">
                            <input formControlName="location" type="text" required>
                            <label for="location" class="floating-label">Location</label>
                            <i class="ri-map-pin-line"></i>
                        </div>
                        <mat-error *ngIf="f.location.touched && f.location.invalid" class="alert alert-danger">
                            <mat-error *ngIf="f.location.errors.required">Location is required</mat-error>
                            <mat-error *ngIf="f.location.errors.pattern">Location can only contain alphabet</mat-error>
                        </mat-error>
                    </div>
                    <div class="input">
                        <div class="input-item">
                            <input formControlName="company" type="text" required>
                            <label for="company" class="floating-label">Company</label>
                            <i class="ri-building-line"></i>
                        </div>
                        <mat-error *ngIf="f.company.touched && f.company.invalid" class="alert alert-danger">
                            <mat-error *ngIf="f.company.errors.required">Company is required</mat-error>
                            <mat-error *ngIf="f.company.errors.pattern">Company can only contain alphabet</mat-error>
                        </mat-error>
                    </div>
                    <div class="input">
                        <div class="input-item">
                            <input formControlName="mobileNo" type="text">
                            <label for="mobileNo" class="floating-label">Mobile No</label>
                            <i class="ri-phone-line"></i>
                        </div>
                        <mat-error *ngIf="f.mobileNo.touched && f.mobileNo.invalid" class="alert alert-danger">
                            <mat-error *ngIf="f.mobileNo.errors.pattern">Mobile No can only contain Numbers</mat-error>
                            <mat-error *ngIf="f.mobileNo.errors.minlength">Mobile No must contain at least 10 digits</mat-error>
                            <mat-error *ngIf="f.mobileNo.errors.maxlength">Mobile No must contain max 10 digits</mat-error>
                        </mat-error>
                    </div>
                    <div class="input">
                        <div class="input-item">
                            <input list="personName" formControlName="personToMeet" >                           
                            <datalist id="personName">
                                <option [value]="item" *ngFor="let item of userDropdownList">
                            </datalist>
                            <label class="floating-label">Person To Meet</label>
                            <i class="ri-shield-user-line"></i>
                        </div>
                        <mat-error *ngIf="f.personToMeet.touched && f.personToMeet.invalid" class="alert alert-danger">
                            <mat-error *ngIf="f.personToMeet.errors.required">Person to meet is required</mat-error>
                        </mat-error>
                    </div>
                    <div class="input">
                        <div class="input-item">
                            <input formControlName="reasonToMeet" type="text" required>
                            <label for="reasonToMeet" class="floating-label">Reason To Meet</label>
                            <i class="ri-slideshow-line"></i>
                        </div>
                        <mat-error *ngIf="f.reasonToMeet.touched && f.reasonToMeet.invalid" class="alert alert-danger">
                            <mat-error *ngIf="f.reasonToMeet.errors.required">Reason to meet is required</mat-error>
                        </mat-error>
                    </div>
                    <div class="input">
                        <div class="input-item">
                            <input formControlName="laptopSerialNo" type="text">
                            <label for="laptopSerialNo" class="floating-label">Laptop Serial No</label>
                            <i class="ri-shield-user-line"></i>
                        </div>
                        <mat-error *ngIf="f.laptopSerialNo.touched && f.laptopSerialNo.invalid" class="alert alert-danger">
                            <mat-error *ngIf="f.laptopSerialNo.errors.pattern">Laptop Serial No can contain Alphabets & Numbers only</mat-error>
                        </mat-error>
                    </div>
                    <div class="input">
                        <div class="input-item">
                            <input formControlName="pendriveDetails" type="text">
                            <label for="pendriveDetails" class="floating-label">Pen drive Details</label>
                            <i class="ri-database-line"></i>
                        </div>
                    </div>
                    <div class="input">
                        <div class="input-item">
                            <input formControlName="visitorCardNo" type="text" required>
                            <label for="visitorCardNo" class="floating-label">Visitor Card No</label>
                            <i class="ri-taxi-line"></i>
                        </div>
                        <mat-error *ngIf="f.visitorCardNo.touched && f.visitorCardNo.invalid" class="alert alert-danger">
                            <mat-error *ngIf="f.visitorCardNo.errors.required">Visitor Card Number is required</mat-error>
                            <mat-error *ngIf="f.visitorCardNo.errors.pattern">Visitor card no. can only contain numbers</mat-error>
                        </mat-error>
                    </div>
                    <!-- <div class="input">
                        <div class="input-item">
                            <input formControlName="signature" type="text" required>
                            <label for="signature" class="floating-label">Signature</label>
                            <i class="ri-pen-nib-line"></i>
                            
                        </div>
                    </div> -->
                    <div class="input">
                        <div class="input-item">
                            <input formControlName="inTime" type="datetime-local" required>
                            <label for="linTime" class="floating-label">InTime</label>
                            <i class="ri-time-line"></i>
                        </div>
                        <mat-error *ngIf="f.inTime.touched && f.inTime.invalid" class="alert alert-danger">
                            <mat-error *ngIf="f.inTime.errors.required">InTime is required</mat-error>
                        </mat-error>
                    </div>
                    <div class="input">
                        <div class="input-item">
                            <input formControlName="outTime" type="datetime-local" required>
                            <label for="outTime" class="floating-label">outTime</label>
                            <i class="ri-time-line"></i>
                        </div>
                        <mat-error *ngIf="f.outTime.touched && f.outTime.invalid" class="alert alert-danger">
                            <mat-error *ngIf="f.outTime.errors.required">OutTime is required</mat-error>
                        </mat-error>
                    </div>
           
                </div>
                <div class="modal-footer">
                    <button type="button" id="closeCreateModal" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary" *ngIf="modeAction === 1" (click)="createvisitor()" [disabled]="!visitorForm.valid" >Create</button>
                    <button type="button" class="btn btn-primary" *ngIf="modeAction === 2" (click)="updatevisitor()" [disabled]="!visitorForm.valid">Update</button>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Delete an item -->
<div class="modal fade" id="deleteVisitor" tabindex="-1">
    <div class="modal-dialog">
        <div class="modal-content pl-5 pr-5">
            <form action="">
                <div class="modal-header">
                    <h5 class="modal-title">Are you sure want to delete?</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                    <div class="text-center">
                        <p>{{deleteConfirmationMsg}}?</p>
                    </div>
                </div>
                <div class="modal-footer">
                    <button id="closeModalDeleteVisitor" type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary" *ngIf="selectedCheckboxData.length > 0" (click)="deletevisitorList()">Yes Delete</button>
                </div>
            </form>
        </div>
    </div>
</div> 